export const renderCellContent = cell => {
    if (cell?.component != null) return cell.component;

    const value = cell?.value ?? cell;
    return typeof value === 'string' || typeof value === 'number' ? value : null;
};
